module.exports = __webpack_public_path__ + "img/disconnect.06bafe52.svg";